<div class="card">
   <div class="card-header">
     <h5>{{ 'Order Status ' | translate }}</h5>
   </div>
   <div class="card-body">
     <div class="chart-container">
       <div id="linechart">
         <apx-chart [chart]="orderStatus2.chart" [dataLabels]="orderStatus2.dataLabels" [stroke]="orderStatus2.stroke" [grid]="orderStatus2.grid" [fill]="orderStatus2.fill" [colors]="orderStatus2.colors" [markers]="orderStatus2.markers" [series]="orderStatus2.series" [xaxis]="orderStatus2.xaxis" [yaxis]="orderStatus2.yaxis" [title]="orderStatus2.title" [legend]="orderStatus2.legend" [responsive]="orderStatus2.responsive"></apx-chart>
       </div>
     </div>
   </div>
 </div>